import { useTheme } from "@deere/fuel-react";
import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";

const MenuButton = ({
  onClick,
  menuIcon,
  featureName,
  displayText,
}: {
  onClick: () => void;
  menuIcon: { Component: typeof SvgIcon };

  featureName: string;
  displayText: string;
}) => {
  const theme = useTheme();
  return (
    <Box minWidth="200px">
      <ListItemButton
        sx={{
          pl: 5,
          height: "40px",
        }}
        data-testid={`${featureName}-button`}
        onClick={onClick}
      >
        <ListItemIcon sx={{ pr: "8px", minWidth: "0" }}>
          <menuIcon.Component
            data-testid={`${featureName}-icon`}
            sx={{
              color: theme.tokens.FuelColorTextIcon,
              width: "24px",
            }}
          />
        </ListItemIcon>
        <ListItemText
          data-testid={`${featureName}-text`}
          primary={displayText}
          primaryTypographyProps={{
            fontSize: "14px",
            fontWeight: 600,
            color: theme.tokens.FuelColorTextHeading,
          }}
        />
      </ListItemButton>
    </Box>
  );
};

export default MenuButton;
